import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 sales_rep_tenant_create_order: { message: "idle" },
};

export const sales_rep_tenant_create_order_Slice = createSlice({
 name: "sales_rep_tenant_create_order",
 initialState,
 reducers: {
  success_sales_rep_tenant_create_order: (state, action) => {
   state.sales_rep_tenant_create_order = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_sales_rep_tenant_create_order: (state, action) => {
   state.sales_rep_tenant_create_order = { status: app_consts.FAIL, message: action.payload };
  },
  reset_sales_rep_tenant_create_order: (state) => {
   state.sales_rep_tenant_create_order = { status: app_consts.IDLE };
  },
  loading_sales_rep_tenant_create_order: (state) => {
   state.sales_rep_tenant_create_order = { status: app_consts.LOADING };
  },
 }
});

export const { success_sales_rep_tenant_create_order, fail_sales_rep_tenant_create_order, reset_sales_rep_tenant_create_order, loading_sales_rep_tenant_create_order } = sales_rep_tenant_create_order_Slice.actions;

export default sales_rep_tenant_create_order_Slice.reducer;